import IntersectionObsManager from "../managers/IntersectionObserver.js";

class Scroller {
    constructor(elem) {
        this.elem = elem;
        this.copy = [...this.elem.querySelectorAll("article")];
        this.images = this.elem.querySelectorAll(".scroller__visual");
        this.current = 0;

        this.init();
    }

    handleIntersection = (entry) => {
        if (entry.isIntersecting) {
            const nextIndex = this.copy.indexOf(entry.target);

            this.copy[this.current].classList.remove("in-view");
            this.images[this.current].classList.remove("in-view");

            entry.target.classList.add("in-view");
            this.images[nextIndex].classList.add("in-view");
            this.current = nextIndex;
        }
    };

    init() {
        this.observer = new IntersectionObsManager({
            rootMargin: "-50% 0% -50% 0%",
        });

        this.copy.forEach((elem) => {
            this.observer.observe(elem, this.handleIntersection);
        });
    }
}

const scrollerElem = document.querySelector(".scroller");
if (scrollerElem) new Scroller(scrollerElem);
